import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router';
import { Field } from 'api/tasks';
import { toastService } from 'components/molecules/toast';
import { useAllFieldsQuery, useUpdateFieldMutation } from 'queries';
import { FieldFormPage, FieldPageProps } from './field-form-page';

interface Params {
  fieldId: string;
}

export const EditFieldPage: FC<FieldPageProps> = (props) => {
  const { title, objectType, onClose } = props;
  const { fieldId } = useParams<Params>();
  const intl = useIntl();
  const mutation = useUpdateFieldMutation(Number(fieldId), {
    onSuccess: (res) => {
      const data = res as Field;

      toastService({
        title: intl.formatMessage({
          id: 'settings.fields.edit.success.title',
        }),
        message: intl.formatMessage(
          {
            id: 'settings.fields.edit.success.message',
          },
          {
            fieldLabel: data ? data.fieldLabel : '',
          },
        ),
      }).success();
    },
  });
  const { data, isLoading } = useAllFieldsQuery();
  const field = data?.find((f) => f.fieldId === Number(fieldId));

  return (
    <FieldFormPage
      isEdit
      isLoading={isLoading}
      onClose={onClose}
      title={title}
      mutation={mutation}
      objectType={objectType}
      field={field}
    />
  );
};
